// eslint-disable-next-line no-case-declarations
import { toast, ToastOptions } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
interface props {
  type: string;
  content: string;
  idLoading?: string | undefined;
}

const ToastProvider = ({ type, content, idLoading }: props) => {
  let notify;
  const toastConfig: ToastOptions = {
    position: "top-center",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: false,
    progress: undefined,
    theme: "light",
  };
  switch (type) {
    case "success":
      notify = () => toast.success(content, { ...toastConfig });
      return notify();
    case "warning":
      notify = () => toast.warning(content, { ...toastConfig });
      return notify();
    case "error":
      notify = () => toast.error(content, { ...toastConfig });
      return notify();
    case "custom":
      notify = () => toast(content, { ...toastConfig });
      return notify();
    case "loading":
      return toast.loading(content, { ...toastConfig });
    case "update success":
      return toast.update(idLoading as string, {
        render: `${content}`,
        type: "success",
        isLoading: false,
        ...toastConfig,
      });
    case "update reject":
      return toast.update(idLoading as string, {
        render: `${content}`,
        type: "error",
        isLoading: false,
        ...toastConfig,
      });
    default:
      return null;
  }
};

export default ToastProvider;
